var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-container"},[_c('iv-input-string',_vm._g(_vm._b({attrs:{"type":_vm.$attrs.styles?.display == 'none' ? 'hidden' : _vm.showEyePassword ? 'text' : 'password'}},'iv-input-string',{
            ..._vm.$attrs,
            ..._vm.$props,
            class: {
                'with-password': _vm.innateValue,
            },
            value: _vm.innateValue,
        },false),{
            ..._vm.$listeners,
            'update:value': ($event) => (_vm.innateValue = $event),
        })),_c('iv-button',{staticClass:"password-eye",class:{
            'attach-right': _vm.state == undefined,
            hide: !_vm.innateValue,
        },attrs:{"icon":`fa-solid fa-${_vm.showEyePassword ? 'eye-slash' : 'eye'}`,"size":_vm.size,"disabled":_vm.disabled,"pill":"","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.doToggleShowEyePassword.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }